import React, { useState, useEffect } from 'react';
import hourglass from '../assets/hourglass.png';

const Spinner = () => {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setRotation((prevRotation) => prevRotation + 45);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const style = {
    transform: `rotate(${rotation}deg)`,
    width: '40px',
    height: '66px',
  };

  return <img src={hourglass} alt={"hourglass"} style={style} />;
};

export default Spinner;
